import styled from 'styled-components';

const SearchItemWrapper = styled.div`
  display: flex;
  align-items: center;

  input {
    background: #e9e9f5;
    opacity: 0.7;
    border-radius: 10px;
    border: none;
    padding: 10px 37px 10px 20px;
    font-size: 18px;
    line-height: 25px;
    color: black;
    font-family: 'Lava Pro', serif;

    @media only screen and (max-width: 767px) {
      font-size: 16px;
    }
  }

  input::placeholder {
    color: #0d092b;
  }

  input:focus,
  input:hover {
    background: #dadaed;
    border: none;
    box-shadow: none;
  }

  img {
    position: relative;
    left: -40px;
    width: 28px;
  }
`;

export default SearchItemWrapper;
